// Models
PJQ.models.erpAdmin.ERPObject = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'erp'
            },
            {
                endpoint: 'objects',
                value: this.erpObject.id
            }
        ]);
    },
    parse: function (model) {
        model = model ? model : {};

        model.id = model.erpObject.id;
        this.erpObject = model.erpObject;
        if (model.relatedObjects) {
            this.relatedItem = model.relatedObjects.relatedItem;
            this.project = model.relatedObjects.project;
        }

        return model;
    },
    createNewContactCompany: function (externalId, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'vendors'
                },
                {
                    endpoint: 'pull',
                    value: externalId
                }]),
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (error) {
            if (typeof callback === 'function') {
                callback(false, error);
            }
        }, this));
    },
    approve: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/approve',
            data: data,
            isAPIv2: true
        }).post().done((res) => {
            if (res && !res.error) {
                this.erpObject = res;
            }

            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            callback(null, err);
        });
    },
    reject: function (rejectReason, callback) {
        this.erpObject.rejectReason = rejectReason;
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/reject',
            data: this.erpObject,
            isAPIv2: true
        }).post().done(_.bind(function (res) {
            if (res && !res.error) {
                this.erpObject = res;
            }

            if (typeof callback === 'function') {
                callback(res);
            }
        }, this));
    },
    pull: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/pull',
            isAPIv2: true
        }).post().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this));
    },
    linkContactCompany: function (company, externalId, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'vendors'
                },
                {
                    endpoint: 'link',
                    value: externalId
                }]),
            data: company,
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (error) {
            if (typeof callback === 'function') {
                callback(false, error);
            }
        }, this));
    },
    archive: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/archive',
            data: this.erpObject,
            isAPIv2: true
        }).post().done(_.bind(function (res) {
            if (res && !res.error) {
                this.erpObject = res;
            }

            if (typeof callback === 'function') {
                callback(res);
            }
        }, this));
    },
    removeFromArchive: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unarchive',
            data: this.erpObject,
            isAPIv2: true
        }).post().done(_.bind(function (res) {
            if (res && !res.error) {
                this.erpObject = res;
            }

            if (typeof callback === 'function') {
                callback(res);
            }
        }, this));
    }
});

//Collections
PJQ.collections.erpAdmin.ERPObjects = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.erpAdmin.ERPObject,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'erp'
            },
            {
                endpoint: 'objects',
                value: this.options.internalModel
            }
        ], [
            {
                parameter: 'statusIds',
                value: this.options.statusIds
            }
        ]);
    },
    parse: function (models) {
        if (models == null || models.objects == null) {
            return models;
        }

        _.each(models.objects, function (model) {
            model.id = model.erpObject.id;
            if (models.projects != null && model.erpObject && model.erpObject.projectId > 0 && model.relatedObjects != null) {
                model.relatedObjects.project = _.findWhere(models.projects, {id: model.erpObject.projectId});
            }
        });

        return models.objects;
    },
    getFeatureCounts: function (externalModel, callback) {
        return new Promise((resolve, reject) => {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: 'objects',
                        value: this.options.internalModel
                    },
                    {
                        endpoint: 'count'
                    }], [
                    {
                        parameter: 'externalModel',
                        value: externalModel
                    }
                ]),
                isAPIv2: true,
            }).get().done(_.bind(function (res) {
                if (typeof callback === 'function') {
                    callback(res);
                }
                resolve(res);
            }, this)).fail(_.bind(function (error) {
                if (typeof callback === 'function') {
                    callback(null);
                }
                reject(new Error("Failed to fetch erp integration sync data"));
            }, this));
        });
    },
    setInternalModel: function (internalModel) {
        this.options.internalModel = internalModel;
    },
    setStatusIds: function (statusIds) {
        this.options.statusIds = statusIds;
    },
    refreshModels: function (type, callback) {
        return new Promise((resolve, reject) => {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: type
                    },
                    {
                        endpoint: 'refresh'
                    }]),
                isAPIv2: true,
            }).post().done(_.bind(function () {
                if (typeof callback === 'function') {
                    callback(true);
                }
                resolve(true);
            }, this)).fail(_.bind(function (error) {
                if (typeof callback === 'function') {
                    callback(false);
                }
                reject(error);
            }, this));
        });
    },
    linkSuggested: function (externalModel, objs, callback) {
        return new Promise((resolve, reject) => {
            if (objs != null && _.size(objs) === 0) {
                if (typeof callback === 'function') {
                    callback([]);
                }
                resolve([]);
                return;
            }

            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: externalModel + 's'
                    },
                    {
                        endpoint: 'linksuggested'
                    }
                ]),
                data: _.size(objs) > 0 ? _.map(objs, (obj) => {
                    return {
                        id: obj.erpObject.id
                    };
                }) : null,
                isAPIv2: true
            }).post().done((res) => {
                if (res && !res.error) {
                    let objs = [];
                    _.each(res, (model) => {
                        objs.push({
                            id: model.id,
                            erpObject: model,
                            relatedObjects: {
                                relatedItem: Object.assign({}, model.data)
                            }
                        });
                    });

                    this.add(objs, {merge: true});
                }

                if (typeof callback === 'function') {
                    callback(res);
                }
                resolve(res);
            }).fail((error) => {
                if (typeof callback === 'function') {
                    callback(null);
                }
                reject(error);
            });
        });
    },
});